import Vue from "vue";
import Vuex from "vuex";
import templateState from "./shared/components/template/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    ...templateState
  }
});
